
<row>
  <column :size="fullWidth ? '100%' : '50%'">
    <row>
      <column>
        <label :for="`update_field_${propertyUpdate.client_id + '_' +propertyUpdate.property_client_id}`" class="a-select-label">
          {{propertyLabel}}
        </label>
      </column>
      <suffix v-if="deleteable && fullWidth">
        <button @click.stop="open" ref="button" class="dropdown-toggle btn-icon clear-area controllers kebab"
                :id="`propertyUpdateDropdown${propertyUpdate.client_id}`" type="button">
          <icon class="kebab"></icon>
          <span class="sr-only">Property Update Dropdown</span>
        </button>
        <context-menu ref="contextMenu"
                      :state="modalStateFor(vueModalID.sortableContextMenu)"
                      :index="vueModalID.sortableContextMenu"
                      fixed
                      @close="toggleModal">
          <ul>
            <li>
              <button @click.stop="deleteItem" class="dropdown-item">Delete</button>
            </li>
          </ul>
        </context-menu>
      </suffix>
    </row>
    <config-field-validation :model="propertyUpdate.parent.parent" :field-name="`clearWhenRequired-${propertyUpdate.parent.client_id}`" message="This property is required">
      <a-select
        v-model="propertyUpdate.property_client_id"
        :options="updateablePropertiesVSelectOptions"
        compress
        @input="onPropertySelected"
        :id="`update_field_${propertyUpdate.client_id + '_' +propertyUpdate.property_client_id}`"
        placeholder="Select a Property..."
        ref="propertySelect"
      ></a-select>
    </config-field-validation>
  </column>

  <column v-if="selectedPropertyIsMultiPicklist" size="100%">
    <row>
      <column :size="fullWidth ? '100%' : '50%'">
        <a-select
          :options="multiPicklistModeOptions"
          v-model="propertyUpdate.multi_picklist_mode"
          placeholder="Select action type..."
          compress
        ></a-select>
      </column>
    </row>
  </column>

  <column v-if="!selectedPropertyIsMultiPicklist" :size="fullWidth ? '100%' : '50%'">
    <div class="radio-inline">
      <input type="checkbox" v-model="propertyUpdate.clear_value" :id="`clear_value_${propertyUpdate.client_id}`" />
      <label :for="`clear_value_${propertyUpdate.client_id}`" >Erase property value</label>
    </div>
  </column>

  <column :size="fullWidth ? '100%' : '50%'" v-if="showNewValueInput">
    <row>
      <column>
        <label :for="`update_value_${propertyUpdate.property_client_id}`" class="a-select-label">
          {{effectiveValueLabel}}
        </label>
      </column>
      <suffix v-if="deleteable && !fullWidth">
        <button @click.stop="open" ref="button" class="dropdown-toggle btn-icon clear-area controllers kebab"
                :id="`propertyUpdateDropdown${propertyUpdate.client_id}`" type="button">
          <icon class="kebab"></icon>
          <span class="sr-only">Property Update Dropdown</span>
        </button>

        <context-menu ref="contextMenu"
                      :state="modalStateFor(vueModalID.sortableContextMenu)"
                      :index="vueModalID.sortableContextMenu"
                      fixed
                      @close="toggleModal">
          <ul>
            <li>
              <button @click.stop="deleteItem" class="dropdown-item">Delete</button>
            </li>
          </ul>
        </context-menu>
      </suffix>
    </row>
    <!--    Slot for input for value to update to-->
    <slot>
      <input :disabled="propertyUpdate.clear_value" id="value_to_update_to" v-model="propertyUpdate.value_to_update_to" type="text">
    </slot>
  </column>
</row>
